export const copyAttribs = ($) => (Object.assign({}, $.attribs));
